import React from "react";
import { Empty, Select } from "antd";
import { EnumRole } from "@src/types/role";
import { useAllProducts } from "@src/hooks/use-all-products";
import { useMe } from "@src/hooks/use-me";
import { FormInstance, SelectProps } from "antd/lib";
import { IntelligenceFormFieldsEnum } from "../../enum";

export const ProductCodeInputField: React.FC<SelectProps & { form: FormInstance }> = ({ form, ...selectProps }) => {
    const { roles, isSuperAdmin } = useMe();

    const productCodesFiltered = roles.map((r: any) => r.productCode);
    const { products, isLoading } = useAllProducts({
        filters: !isSuperAdmin
            ? [
                  {
                      field: "code",
                      operator: "in",
                      value: productCodesFiltered,
                  },
              ]
            : [],
        enabled: productCodesFiltered.length > 0,
    });
    const renderLabelProduct = (product: any) => {
        return (
            <div className="flex items-center">
                <img src={product.icon} className="w-4 h-4 rounded-[2px] mr-2" />
                {product.name} - {product.productCode}
            </div>
        );
    };

    const options = React.useMemo(() => {
        return products.map((product) => {
            const role = roles.find((r: { productCode: string }) => r.productCode === product.code);
            const disabled = !isSuperAdmin && role.role === EnumRole.ProductViewer;
            return {
                label: renderLabelProduct(product),
                value: product.code,
                title: product.name,
                disabled,
            };
        });
    }, [products]);

    return (
        <Select
            options={options}
            loading={isLoading}
            placeholder="Select product"
            showSearch
            filterOption={(input, option) => {
                const { title, value } = option as any;
                if (!value || !title) return false;
                return (
                    title.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            }}
            allowClear
            style={{ width: 300 }}
            notFoundContent={
                <Empty className="text-[12px]" description="You are not in product! Please contact your admin" />
            }
            {...selectProps}
            onChange={(value) => {
                selectProps.onChange?.(value);
                form.setFieldValue(IntelligenceFormFieldsEnum.PLATFORM, [`${value}a`, `${value}i`]);
            }}
        />
    );
};
